import React, { useEffect } from 'react';
import {
  List,
  ListItem,
  ListItemAvatar,
  IconButton,
  Grid,
  Divider,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
} from '@mui/material';
import {
  ArrowBackIos,
  Logout,
  VpnKey,
  SupportAgent,
  BusAlert,
  Forum,
} from '@mui/icons-material';
import { connect } from 'react-redux';
import * as common from '../../appRedux/actions/common';
import * as login from '../../appRedux/actions/login';
import * as info from '../../appRedux/actions/info';
import IntlMessages from '../../util/IntlMessages';
import Comeback from '../../components/comeback';
import * as router from '../../constants/router';
import * as tools from '../../util/tools';
import useStyles from './styles';

function Index(props) {
  const classes = useStyles();

  useEffect(() => {
    props.getSupportNumberAction();
  }, []);

  return (
    <React.Fragment>
      <Comeback title={<IntlMessages id="profile" />} />
      <Grid className={classes.root}>
        <List dense={false}>
          <Divider />
          <ListItem onClick={() => props.redirectAction(router.TANKER_FAILURE)}>
            <ListItemAvatar>
              <BusAlert />
            </ListItemAvatar>
            <ListItemText primary={<IntlMessages id="tankerFailure" />} />
            <ListItemSecondaryAction>
              <IconButton edge="end">
                <ArrowBackIos fontSize="small" />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <ListItem onClick={() => props.redirectAction(router.COMMUNICATION_MANAGER)}>
            <ListItemAvatar>
              <Forum />
            </ListItemAvatar>
            <ListItemText primary={<IntlMessages id="communicationWithManagement" />} />
            <ListItemSecondaryAction>
              <IconButton edge="end">
                <ArrowBackIos fontSize="small" />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <ListItem onClick={() => props.redirectAction(router.CHANGE_PASSWORD)}>
            <ListItemAvatar>
              <VpnKey />
            </ListItemAvatar>
            <ListItemText primary={<IntlMessages id="changePassword" />} />
            <ListItemSecondaryAction>
              <IconButton edge="end">
                <ArrowBackIos fontSize="small" />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <ListItem
            onClick={() => (window.location.href = tools.telFormat(props.supportNumber))}
          >
            <ListItemAvatar>
              <SupportAgent />
            </ListItemAvatar>
            <ListItemText primary={<IntlMessages id="contactSupport" />} />
            <ListItemSecondaryAction>
              <IconButton edge="end">
                <ArrowBackIos fontSize="small" />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <ListItem onClick={() => props.logoutAction()}>
            <ListItemAvatar>
              <Logout />
            </ListItemAvatar>
            <ListItemText primary={<IntlMessages id="logout" />} />
            <ListItemSecondaryAction>
              <IconButton edge="end">
                <ArrowBackIos fontSize="small" />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
          <Divider />
          <Typography variant="h5" className={classes.version}>
            <IntlMessages id="version" /> : {tools.getVersion()}
          </Typography>
        </List>
      </Grid>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return {
    supportNumber: state.field.supportNumber,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logoutAction: () => dispatch(login.logoutAction()),
    redirectAction: (router) => dispatch(common.redirectAction(router)),
    getSupportNumberAction: () => dispatch(info.getSupportNumberAction()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
